import { render } from "./PageTransitionStart.vue?vue&type=template&id=47d50c79&ts=true"
import script from "./PageTransitionStart.vue?vue&type=script&lang=ts"
export * from "./PageTransitionStart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__